const TOKEN_KEY = 'rp_token';

export function getToken() { return localStorage.getItem(TOKEN_KEY); }
export function setToken(t) { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); }

async function request(url, opts = {}) {
  const headers = opts.headers || {};
  const token = getToken();
  if (token) headers['Authorization'] = 'Bearer ' + token;
  if (opts.json !== undefined) {
    headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(opts.json);
    delete opts.json;
  }
  const res = await fetch(url, { ...opts, headers });
  const ct = res.headers.get('content-type') || '';
  if (!ct.includes('application/json')) {
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res;
  }
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || ('HTTP ' + res.status));
  return data;
}

export const api = {
  // auth
  institutions: () => request('/api/auth/institutions'),
  login: (body) => request('/api/auth/login', { method: 'POST', json: body }),
  forgot: (body) => request('/api/auth/forgot-password', { method: 'POST', json: body }),
  me: () => request('/api/auth/me'),
  changePassword: (body) => request('/api/auth/change-password', { method: 'POST', json: body }),
  // folders
  listFolders: () => request('/api/folders'),
  createFolder: (body) => request('/api/folders', { method: 'POST', json: body }),
  renameFolder: (id, name) => request('/api/folders/' + id, { method: 'PATCH', json: { name } }),
  deleteFolder: (id) => request('/api/folders/' + id, { method: 'DELETE' }),
  // files
  listFiles: (params = {}) => {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) if (v != null && v !== '') q.set(k, v);
    return request('/api/files?' + q.toString());
  },
  uploadFiles: (formData) => fetch('/api/files/upload', {
    method: 'POST',
    headers: { Authorization: 'Bearer ' + getToken() },
    body: formData,
  }).then(async r => {
    const d = await r.json();
    if (!r.ok) throw new Error(d.error || 'upload failed');
    return d;
  }),
  fileVersions: (id) => request('/api/files/' + id + '/versions'),
  patchFile: (id, body) => request('/api/files/' + id, { method: 'PATCH', json: body }),
  deleteVersion: (id, v) => request(`/api/files/${id}/versions/${v}`, { method: 'DELETE' }),
  disk: () => request('/api/files/disk'),
  downloadVersionUrl: (id, v) => `/api/files/${id}/versions/${v}/download?token=${encodeURIComponent(getToken() || '')}`,
  // posts (notices, discussions share interface)
  listPosts: (kind) => request('/api/' + kind),
  getPost: (kind, id) => request('/api/' + kind + '/' + id),
  createPost: (kind, body) => request('/api/' + kind, { method: 'POST', json: body }),
  patchPost: (kind, id, body) => request('/api/' + kind + '/' + id, { method: 'PATCH', json: body }),
  deletePost: (kind, id) => request('/api/' + kind + '/' + id, { method: 'DELETE' }),
  // comments (kind = 'discussions' | 'notices')
  listComments: (kind, postId) => request('/api/' + (kind === 'notices' ? 'notice-comments' : 'discussion-comments') + '/' + postId),
  addComment: (kind, postId, html) => request('/api/' + (kind === 'notices' ? 'notice-comments' : 'discussion-comments') + '/' + postId, { method: 'POST', json: { content_html: html } }),
  deleteComment: (kind, postId, cid) => request('/api/' + (kind === 'notices' ? 'notice-comments' : 'discussion-comments') + '/' + postId + '/' + cid, { method: 'DELETE' }),
  // cowrite
  listDocs: () => request('/api/cowrite'),
  getDoc: (id) => request('/api/cowrite/' + id),
  createDoc: (body) => request('/api/cowrite', { method: 'POST', json: body }),
  saveDoc: (id, body) => request('/api/cowrite/' + id + '/save', { method: 'POST', json: body }),
  deleteDoc: (id) => request('/api/cowrite/' + id, { method: 'DELETE' }),
  docVersions: (id) => request('/api/cowrite/' + id + '/versions'),
  docVersion: (id, v) => request('/api/cowrite/' + id + '/versions/' + v),
  rollback: (id, v) => request('/api/cowrite/' + id + '/rollback/' + v, { method: 'POST' }),
  cowritePdfUrl: (id, v) =>
    '/api/cowrite/' + id + (v ? '/versions/' + v : '') + '/pdf?token=' + encodeURIComponent(getToken() || ''),
};
